
import React, { useState } from "react";
import ActionButton from "../../components/ActionButton";
import { Link, useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import DashboardCard from "../../components/DashboardCard";
import { LIGHT_BLUE_COLOR } from "../../constants";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useForm } from "react-hook-form";
import ShowErrorAlert from "../../components/ErrorAlert";
import { extractErrorMessage } from "../../utils";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import DashboardHeading from "../../components/DashboardHeading";
import Label from "../../components/Label";
import CustomInput from "../../components/CustomInput";
import { PRICE_MASTER_FIELDS } from "./Config.constant";
import ConfigurationsHeader from "./ConfigurationsHeader";
import ShowSuccessAlert from "../../components/SuccessAlert";

const AddUnit = () => {
    const {
        handleSubmit,
        formState: { errors },
        getValues,
        control,
        reset
    } = useForm({
        values: {
            unit: "",
        },
    });
    const navigate = useNavigate();

    // Redux Store
    const {
        auth: {
            token,
            user: { _id: userId },
        },
    } = useSelector((state) => state);

    // State Variables
    const [loading, setLoading] = useState(false);

    async function priceMasterReq(body) {
        setLoading(true);
        try {
            await axios.post(`${BASE_URL}/users/${userId}/priceMasters`, body, {
                headers: {
                    Authorization: token,
                },
            });
            ShowSuccessAlert("Price Master added successfully");
            setTimeout(()=>{
                setLoading(false);
                navigate("/admins/configurations/units");
            }, 2000);
            reset();
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    function onSubmit(data) {
        priceMasterReq(data);
    }

    return (
        <DashboardLayout >
            <ConfigurationsHeader />
            <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex justify-between align-center">
                        <div className="flex align-center">
                            <Link to="/admins/configurations/priceMasters">
                                <MdOutlineArrowBackIosNew size={20} />
                            </Link>
                            <DashboardHeading>Add</DashboardHeading>
                        </div>
                        <ActionButton type="submit" disabled={loading}>
                            {loading ? <ClipLoader color="black" size={20} /> : "Add"}
                        </ActionButton>
                    </div>
                    {/* form starts here */}
                    <DashboardCard>
                        {PRICE_MASTER_FIELDS(getValues).map(
                            ({ name, required, label, type, rules, errorText }) => (
                                <div key={name} className="mt-3">
                                    <Label required={required}>{label}</Label>
                                    <CustomInput
                                        name={name}
                                        type={type}
                                        control={control}
                                        rules={rules}
                                        errors={errors}
                                        errorText={errorText}
                                    />
                                </div>
                            )
                        )}
                    </DashboardCard>
                </form>
            </DashboardCard>
            {/* <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <div style={{display: "flex", flexDirection: "row"}}>
                <span style={{fontSize: "32px"}}>OR</span>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/priceMasters"  >
                    <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                        <FiEdit color="white" size={20} className="me-2" />
                        <small>All Price Masters</small>
                    </ActionButton></Link>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/updatePriceMaster"  >
                <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                    <FiEdit color="white" size={20} className="me-2" />
                    <small>Update Price Master</small>
                </ActionButton></Link>
                </div>
            </DashboardCard> */}
        </DashboardLayout>

    )
}

export default AddUnit;